// extracted by mini-css-extract-plugin
export default {"mediaSumWrap":"mediaSumData_mediaSumWrap__iJKq1","snsDetail":"mediaSumData_snsDetail__36KBR","snsTitle":"mediaSumData_snsTitle__7eYNw","total":"mediaSumData_total__azGqZ"};